import React from "react";

export const formatDistance = distance => {
    const km = distance / 1000
    const result = km.toFixed(1)
    return result
};



// WEBPACK FOOTER //
// ./components/common/FormatDistance.js